import * as Api from '../../utils/request'


export default {
	
	/**
	 * 获取首页列表页数据
	 * @returns {Promise.<*>}
	 */

	//指数板块
	async getList(){
		return await Api.get({
			url:'/H5ReactIndex/indexPlate',
			params:{}
		})
	},
	//专栏列表板块
	async getColumnList(page){
		return await Api.get({
			url:'/H5ReactNews/index',
			params:{
				page
			}
		})
	},
	//专栏详情板块
	async getColumn(id){
		return await Api.get({
			url:'/H5ReactLives/detail',
			params:{
				id 
			}
		})
	},
	//获取评论列表，要闻，专栏，直播中的精彩评论
	async getComment(id, kind ){
		return await Api.get({
			url:'/H5ReactExpress/comment',
			params:{
				id,
				kind
			}
		})
	},
	//获取专栏详情页精彩推荐
	async getGoodRecommend(){
		return await Api.get({
			url:'/H5ReactNews/goodRecommend',
			params:{
			}
		})
	},
	//要闻详情板块
	async getImportNewsDetail(id){
		return await Api.get({
			// url:'mobile//H5ReactExpress/detail',
			url:'/H5ReactExpress/detail',
			params:{
				id
			}
		})
	},
	//详情页点赞接口
	async addPraise(id ,kind){
		return await Api.get({
			url:'/H5ReactLives/addPraise',
			params:{
				id,
				kind
			}
		})
	},
		//详情页点踩接口
		async reduce(id ,kind){
			return await Api.get({
				url:'/H5ReactLives/reduce',
				params:{
					id,
					kind
				}
			})
		}
}
